const mapper = {
  gn: ["Geneza", "GEN"],
  ex: ["Exod", "EXO"],
  lv: ["Leviticul", "LEV"],
  nm: ["Numeri", "NUM"],
  dt: ["Deuteronomul", "DEU"],
  js: ["Iosua", "JOS"],
  jud: ["Judecatorii", "JDG"],
  rt: ["Rut", "RUT"],
  "1sm": ["1Samuel", "1SA"],
  "2sm": ["2Samuel", "2SA"],
  "1rg": ["1Regi", "1KI"],
  "2rg": ["2Regi", "2KI"],
  "1cr": ["1Cronici", "1CH"],
  "2cr": ["2Cronici", "2CH"],
  ezr: ["Ezra", "EZR"],
  ne: ["Neemia", "NEH"],
  et: ["Estera", "EST"],
  iov: ["Iov", "JOB"],
  ps: ["Psalmii", "PSA"],
  prv: ["Proverbe", "PRO"],
  ec: ["Eclesiastul", "ECC"],
  cc: ["Cantarea-Cantarilor", "SNG"],
  is: ["Isaia", "ISA"],
  ir: ["Ieremia", "JER"],
  png: ["Plangerile lui Ieremia", "LAM"],
  ez: ["Ezechiel", "EZK"],
  dn: ["Daniel", "DAN"],
  ho: ["Osea", "HOS"],
  il: ["Ioel", "JOL"],
  am: ["Amos", "AMO"],
  ob: ["Obadia", "OBA"],
  in: ["Iona", "JON"],
  mi: ["Mica", "MIC"],
  na: ["Naum", "NAM"],
  hc: ["Habacuc", "HAB"],
  tf: ["Tefania", "ZEP"],
  hg: ["Hagai", "HAG"],
  zh: ["Zaharia", "ZEC"],
  ml: ["Maleahi", "MAL"],
  mt: ["Matei", "MAT"],
  mc: ["Marcu", "MRK"],
  lc: ["Luca", "LUK"],
  io: ["Ioan", "JHN"],
  fpt: ["Fapte", "ACT"],
  rm: ["Romani", "ROM"],
  "1co": ["1Corinteni", "1CO"],
  "2co": ["2Corinteni", "2CO"],
  gl: ["Galateni", "GAL"],
  efe: ["Efeseni", "EPH"],
  fp: ["Filipeni", "PHP"],
  cl: ["Coloseni", "COL"],
  "1ts": ["1Tesaloniceni", "1TH"],
  "2ts": ["2Tesaloniceni", "2TH"],
  "1tm": ["1Timotei", "1TI"],
  "2tm": ["2Timotei", "2TI"],
  tt: ["Tit", "TIT"],
  fil: ["Filimon", "PHM"],
  ev: ["Evrei", "HEB"],
  ib: ["Iacov", "JAS"],
  "1pe": ["1Petru", "1PE"],
  "2pe": ["2Petru", "2PE"],
  "1io": ["1Ioan", "1JN"],
  "2io": ["2Ioan", "2JN"],
  "3io": ["3Ioan", "3JN"],
  id: ["Iuda", "JUD"],
  ap: ["Apocalipsa", "REV"],
};

const findBook = (name) => Object.entries(mapper).find(([, [romanianName]]) => romanianName === name);

export const map = (name) => findBook(name)?.[0];

export const mapYouVersion = (name) => findBook(name)?.[1]?.[1];

export const localizeReference = (reference, translate) =>
  reference
    .split(";")
    .map((part) => {
      const trimmedPart = part.trim();
      const book = Object.values(mapper).find(
        ([romanianName]) => trimmedPart === romanianName || trimmedPart.startsWith(`${romanianName} `),
      );

      if (!book) {
        return trimmedPart;
      }

      const [romanianName, usfmCode] = book;
      return `${translate(`dailyBible.reading.books.${usfmCode}`)}${trimmedPart.slice(romanianName.length)}`;
    })
    .join("; ");
